import { render, staticRenderFns } from "./PropertyCardComponent.vue?vue&type=template&id=525aee94&scoped=true"
import script from "./PropertyCardComponent.vue?vue&type=script&lang=js"
export * from "./PropertyCardComponent.vue?vue&type=script&lang=js"
import style0 from "./PropertyCardComponent.vue?vue&type=style&index=0&id=525aee94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525aee94",
  null
  
)

export default component.exports